module.exports = __webpack_public_path__ + "img/9_58.6ff61c08.png";